import { render, staticRenderFns } from "./SaveSearch.vue?vue&type=template&id=20dece52&"
import script from "./SaveSearch.vue?vue&type=script&lang=js&"
export * from "./SaveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports